function showflows() {
  if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!=undefined) {
    let  userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
    if(userInfoMd.qydm=='9998' || userInfoMd.qydm=='200072' || userInfoMd.qydm=='3333' || userInfoMd.qydm=='2250' || userInfoMd.qydm=='7566'){
      return true
    }else{
      return false
    }

  }
 
}
export{
  showflows
}


// WEBPACK FOOTER //
// ./src/util/show.js